// extracted by mini-css-extract-plugin
module.exports = {"parklist":"Pages_parklist__1do4V"};